import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddDashboardSectionDialog from "pages/web-pages/AddDashboardSectionDialog";
import DashboardSection from "pages/web-pages/DashboardSection";
import { addDashboardSection } from "actions/webPages";
import {
  DashboardContainer,
  DashboardNoDataFound,
  DashboardHeader,
} from "styles/pages/web-pages";

const Dashboard = ({ data, refresh, isAdmin = true }) => {
  const dispatch = useDispatch();
  const [addSectionDialog, setAddSectionDialog] = useState(false);

  const Header = () => {
    if (!isAdmin) return null;
    return (
      <DashboardHeader>
        <AddCircleIcon onClick={() => setAddSectionDialog(true)} />
        {addSectionDialog && (
          <AddDashboardSectionDialog
            open={addSectionDialog}
            setOpen={() => setAddSectionDialog(false)}
            addSection={async (sectionName) => {
              setAddSectionDialog(false);
              await dispatch(addDashboardSection({ sectionName }));
              refresh();
            }}
          />
        )}
      </DashboardHeader>
    );
  };

  if (!data?.length)
    return (
      <DashboardContainer $isAdmin={isAdmin}>
        <Header />
        <Paper elevation={3}>
          <DashboardNoDataFound>No Data Found !</DashboardNoDataFound>
        </Paper>
      </DashboardContainer>
    );

  return (
    <DashboardContainer $isAdmin={isAdmin}>
      <Header />
      <DashboardSection sections={data} refresh={refresh} isAdmin={isAdmin} />
    </DashboardContainer>
  );
};

export default Dashboard;
